import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const RECOMMENDATIONS_WIRING: Wiring = {
  [EVENTS.RecommendationsNoResultsShowAll]: [
    WIRES.enableNoResultsInfiniteScrollRecommendations,
    WIRES.increaseNoResultsRecommendationsPage,
    WIRES.getNoResultsRecommendations
  ],
  [EVENTS.RecommendationsEmptySearchShowAll]: [
    WIRES.enableEmptySearchInfiniteScrollRecommendations,
    WIRES.increaseEmptySearchRecommendationsPage,
    WIRES.getEmptySearchRecommendations
  ],
  [EVENTS.DiscoveryWallSuccessWithoutResults]: [
    WIRES.getEmptySearchRecommendations
  ],
  [EVENTS.DiscoveryWallBlockShow]: [
    WIRES.trackDiscoveryWallBlockShow
  ]
};
